import React from 'react';

interface CollapsibleSectionProps {
  id: string;
  title: string;
  icon: string;
  color: string;
  children: React.ReactNode;
  isExpanded: boolean;
  onToggle: (id: string) => void;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  id,
  title,
  icon,
  color,
  children,
  isExpanded,
  onToggle
}) => {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <button
        onClick={() => onToggle(id)}
        className={`w-full px-3 py-2 text-left bg-gradient-to-r from-${color}-50 to-${color}-100 dark:from-${color}-900/20 dark:to-${color}-800/20 hover:from-${color}-100 hover:to-${color}-200 dark:hover:from-${color}-800/30 dark:hover:to-${color}-700/30 transition-colors flex items-center justify-between`}
      >
        <div className="flex items-center space-x-2">
          <span className="text-sm">{icon}</span>
          <span className={`text-xs font-medium text-${color}-700 dark:text-${color}-300`}>
            {title}
          </span>
        </div>
        <span className={`text-xs text-${color}-500 transform transition-transform ${isExpanded ? 'rotate-180' : ''}`}>
          ▼
        </span>
      </button>
      {isExpanded && (
        <div className="p-3 bg-white dark:bg-gray-800">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
